export const ERROR_CODES = {
  INVALID_OTP: 'invalid_otp',
  RETRIES_EXCEEDED: 'number_of_retries_exceeded',
  VALIDATION_FAILED: 'validation_failed',
  INVALID_TOKEN: 'invalid_token',
  DENIED_DRS: 'denied_by_drs',
  INVALID_USER: 'invalid_user',
  MISSING_PARAMETERS: 'missing_parameters',
  UNKNOWN_DEVICE: 'unknown_device',
  INVALID_INIT_OPTIONS: 'invalid_initialization',
  DUPLICATED_OPERATION: 'duplicated_operation',
  USER_NOT_FOUND: 'user_not_found'
} as const;

export type ErrorCode = typeof ERROR_CODES[keyof typeof ERROR_CODES];

export const EXCEPTION_ERROR_CODES = {
  INVALID_INIT: 'invalid_initialization_options',
  NOT_INITIALIZED: 'not_initialized',
  INVALID_STATE: 'invalid_state',
  MISSING_PREPARE: 'missing_prepare_step',
  NETWORK_ERROR: 'network_error',
  SERVER_ERROR: 'server_error',
  INVALID_CREDENTIALS: 'invalid_credentials',
  CLIENT_RESPONSE_INVALID: 'client_response_not_valid',
  NO_ACTIVE_JOURNEY: 'no_active_journey',
  DRS_CLIENT_PREFIX: 'client_error_',
  DRS_SERVER_PREFIX: 'server_error_',
  DRS_DISABLED_PREFIX: 'disabled_sdk_',
  DRS_COMMUNICATION_PREFIX: 'communication_error_',
  DRS_UNEXPECTED_PREFIX: 'unexpected_error_'
} as const;

export type ExceptionErrorCode = typeof EXCEPTION_ERROR_CODES[keyof typeof EXCEPTION_ERROR_CODES];

export const ERROR_CODE_TO_TRANSLATION_KEY = {
  [ERROR_CODES.RETRIES_EXCEEDED]: {
    head: 'Transmit.mfs_email_otp_exceeded_max_tries_title',
    description: 'Transmit.mfs_email_otp_exceeded_max_tries_description',
    type: 'info'
  },
  [ERROR_CODES.VALIDATION_FAILED]: {
    head: 'Transmit.validation_failed',
    description: 'Transmit.validation_failed_description',
    type: 'info'
  },
  [ERROR_CODES.INVALID_TOKEN]: {
    head: 'Transmit.invalid_token_title',
    description: 'Transmit.invalid_token',
    type: 'info'
  },
  [ERROR_CODES.DENIED_DRS]: {
    head: 'Transmit.denied_drs_title',
    description: 'Transmit.denied_drs',
    type: 'info'
  },
  [ERROR_CODES.INVALID_USER]: {
    head: 'Transmit.invalid_user_title',
    description: 'Transmit.invalid_user',
    type: 'info'
  },
  [ERROR_CODES.MISSING_PARAMETERS]: {
    head: 'Transmit.generic_error_title',
    description: 'Transmit.generic_error_description',
    type: 'info'
  },
  [ERROR_CODES.UNKNOWN_DEVICE]: {
    head: 'Transmit.unknown_device_title',
    description: 'Transmit.unknown_device_description',
    type: 'info'
  },
  [ERROR_CODES.USER_NOT_FOUND]: {
    head: 'Transmit.user_not_found_title',
    description: 'Transmit.user_not_found_description',
    type: 'info'
  }
} as const;
